export const tabOptions = [
  {
    name: 'PRS',
    key: 'PRS'
  },
  {
    name: 'DRS',
    key: 'DRS'
  }
];

export const entityTypes = {
  PRS: 'PRS',
  DRS: 'DRS'
};

export const costTypes = {
  MAREKT_COST: 'MARKET_COST',
  HANDLING_COST: 'HANDLING_COST'
};

export const subTabOptions = [
  {
    name: 'Market Cost',
    key: 'MARKET_COST'
  },
  {
    name: 'Handling Cost',
    key: 'HANDLING_COST'
  }
];

export const tableData = {
  PRS: {
    headers: [
      'PRS No.',
      'Arriving Captain',
      'Cluster Name',
      'OU Code',
      'Vehicle Type',
      '# of CNs',
      'WT (kgs)',
      'PKGS',
      'Cost',
      'Cost Status',
      'Actions'
    ],
    dataKeys: [
      'prsId',
      'pickupUserName',
      'clusterName',
      'locationCode',
      'vehicleType',
      'numberOfConsignments',
      'totalWeight',
      'numberOfBoxes',
      'totalCost',
      'displayStatus'
    ]
  },
  DRS: {
    headers: [
      'DRS Id',
      'BP/Vendor/CL',
      'Cluster Name',
      'OU Code',
      'Delivery PA/Captain',
      'Scheduled Departure',
      'Vehicle Type',
      'Wt- Pkgs',
      'Cost',
      'Cost Status',
      'Actions'
    ],
    dataKeys: [
      'drsId',
      'transportationPartnerName',
      'clusterName',
      'locationCode',
      'userName',
      'scheduledDispatchTime',
      'vehicleType',
      'totalBoxes,totalWeight',
      'totalCost',
      'displayStatus'
    ]
  }
};

export const subTableDataPrs = {
  headers: [
    'CNs',
    'Dropoff Pending from (Days)',
    'Client',
    'From',
    'To',
    'WT(Kgs)',
    'PKGS'
  ],
  dataKeys: [
    'cnote',
    'firstInTransitToOuTime',
    'clientName',
    'fromPinCode',
    'toPinCode',
    'weight',
    'totalBoxes'
  ]
};

export const subTableDataDrs = {
  headers: [
    'CNo.',
    'Client (code)',
    'Customer Promise Date',
    'Rescheduled Promise Date',
    'Wt - Pkgs',
    'Pincode'
  ],
  dataKeys: [
    'cnote',
    'clientCode',
    'internalPromisedDeliveryDateTime',
    'rescheduledDeliveryDateTime',
    'weight',
    'toPinCode'
  ]
};

export const sortTableData = rows => {
  (rows || []).sort((a, b) => {
    if (a.expenseStatus === expenseStatus.waitingForSecondApproval) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.waitingForSecondApproval) {
      return 1;
    }
    if (a.expenseStatus === expenseStatus.waitingForApproval) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.waitingForApproval) {
      return 1;
    }
    if (a.expenseStatus === expenseStatus.approved) {
      return -1;
    }
    if (b.expenseStatus === expenseStatus.approved) {
      return 1;
    }
  });
};
export const expenseStatus = {
  waitingForSecondApproval: 'WAITING_FOR_SECOND_APPROVAL',
  waitingForApproval: 'WAITING_FOR_APPROVAL',
  approved: 'APPROVED',
  rejected: 'REJECTED',
  autoRejected: 'AUTO_REJECTED',
  autoRejectedBeforeFirstApprovalWithSecondApproval:
    'AUTO_REJECTED_BEFORE_FIRST_APPROVAL_WITH_SECOND_APPROVAL',
  autoRejectedAfterFirstApprovalWithSecondApproval:
    'AUTO_REJECTED_AFTER_FIRST_APPROVAL_WITH_SECOND_APPROVAL',
  reapproved: 'REAPPROVED'
};

export const isAutoRejectedStatus = status => {
  return (
    status === expenseStatus.autoRejected ||
    status ===
      expenseStatus.autoRejectedBeforeFirstApprovalWithSecondApproval ||
    status === expenseStatus.autoRejectedAfterFirstApprovalWithSecondApproval
  );
};

export const reasonTypes = {
  rejection: 'EXPENSE_REJECTION',
  reapproval: 'EXPENSE_RE_APPROVAL'
};

const getSafeNumericCost = val => {
  if (val === null || val === undefined) {
    return 0;
  }
  const parsed = parseFloat(val);
  return Number.isNaN(parsed) ? 0 : parsed;
};

const isValidCost = val => {
  if (val === null || val === undefined) {
    return false;
  }
  const str = String(val).trim();
  if (str === '') {
    return false;
  }
  return !Number.isNaN(parseFloat(str));
};

export const getModifiedExpenseComponents = (
  updatedComponents,
  originalComponents
) => {
  const expenseComponents = [];

  (updatedComponents || []).forEach(updated => {
    if (!isValidCost(updated.capturedCost)) {
      return;
    }

    const original = (originalComponents || []).find(o => o.id === updated.id);
    const originalCost = original
      ? getSafeNumericCost(original.capturedCost)
      : 0;
    const updatedCost = parseFloat(updated.capturedCost);

    if (originalCost !== updatedCost) {
      expenseComponents.push({
        id: updated.id,
        finalCost: updatedCost
      });
    }
  });
  return expenseComponents;
};
